import {createAction} from '@reduxjs/toolkit';

export const scrollToTop = createAction('SCROLL_TO_TOP');
export const scrollToClassName = createAction<ScrollToClassNamePayload>('SCROLL_TO_CLASSNAME');
export const scrollToError = createAction('SCROLL_TO_ERROR');

export interface ScrollToClassNamePayload {
    offset?: number;
    className: string;
}
